var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.374,
    r: 10,
    fill: "#102262"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m8.013 14.5-.03-.016L8 14.5h.013Zm-.627-.547-.016-.021c.277.144.584.221.896.224a1.947 1.947 0 0 0 1.94-1.877v-9.28h2.317c-.002.196.014.391.048.584a3.22 3.22 0 0 0 1.411 2.11l.004.005-.004-.005a3.16 3.16 0 0 0 1.752.53v.501l.004.001v1.796a5.492 5.492 0 0 1-3.216-1.032v4.718a4.266 4.266 0 0 1-4.261 4.26 4.21 4.21 0 0 1-2.442-.722 4.218 4.218 0 0 1-.14-.155 4.265 4.265 0 0 1-1.482-4.672 4.253 4.253 0 0 1 4.064-2.98c.193.002.384.019.574.049v.548a5.262 5.262 0 0 0-.005 0v1.822a1.993 1.993 0 0 0-.574-.09 1.94 1.94 0 0 0-1.71 1.041 1.95 1.95 0 0 0 .84 2.645Z",
    clipRule: "evenodd"
  })));
};
export default SvgTiktok;